import React, { Fragment, useState, useContext } from 'react'
import { Typography, Checkbox, makeStyles, Collapse, List, ListItem, ListItemText } from '@material-ui/core'
import { withTranslation } from 'react-i18next'
import { PageContext } from '../../Context/PageProvider'
import Modal from './Modal'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

function PermissionsModal({ open, onClose, t, role, title }) {
    const context = useContext(PageContext)
    const api = context.api
    const classes = useStyles();
    const [enabledPermissions, setEnabledPermissions] = useState(role.permissions)
    const [permissions, setPermissions] = useState(null)
    const [loading, setLoading] = useState(false)
    const [collapseList, setCollapseList] = useState(null)

    const getPermissions = async () => {
        try {
            const permissionList = await api.adminService.getPermissions()
            setPermissions(permissionList)
        } catch (error) {
            console.log(error)
        }
    }

    const onSubmit = async () => {
        try {
            setLoading(true)
            const updateData = { ...role, permissions: enabledPermissions }
            await api.adminService.updateRole(updateData)
            setTimeout(() => {
                onClose()
            }, 500)
        } catch (error) {
            console.log(error)
        }

    }

    const handlePermissionChange = (checkbox) => {
        const permissionName = checkbox.target.ariaLabel
        const indexChecked = enabledPermissions.indexOf(permissionName)
        if (indexChecked > -1) {
            enabledPermissions.splice(indexChecked, 1)
        } else {
            setEnabledPermissions(prevState => [...prevState, permissionName])
        }
    }

    const onClickModuleTitle = (title) => {
        setCollapseList({ [title]: !collapseList || !collapseList[title] })
    }

    useState(() => {
        getPermissions()
    }, [])

    if (permissions === null) return null
    
    return (
        <div>

            <Modal open={open} aria-labelledby="permissions-modal" title={title} onSubmit={onSubmit} onCancel={onClose} loading={loading}>
                <List component="div" disablePadding>
                    <ListItem divider className={classes.infoContainer}>
                        <ListItemText primary={t('modules')} className={classes.infoName} />
                        <Typography component="span">
                            {t('status')}
                        </Typography>
                    </ListItem>
                </List>
                {permissions.map((module) => {
                    return module.permissions?.length > 0 && <Fragment key={`${module.module}-fragment`}>
                        <List component="div" disablePadding>
                            <ListItem divider onClick={() => onClickModuleTitle(module.title)} className={classes.listItemTitle}>
                                <Typography variant="body2" component="span">
                                    {module.title}
                                </Typography>
                                {collapseList && collapseList[module.title] ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            {
                                module.permissions.map(permission => (
                                    <Collapse in={collapseList && collapseList[module.title]}>
                                        <List component="div" disablePadding>
                                            <ListItem divider>
                                                <ListItemText disableTypography primary={permission.title} className={classes.permissionTitle} />
                                                <Checkbox defaultChecked={role.permissions.indexOf(permission.name) > -1 ? true : false} onChange={handlePermissionChange} color="primary" inputProps={{ 'aria-label': permission.name }} />
                                            </ListItem>
                                        </List>
                                    </Collapse>
                                ))
                            }
                        </List>
                    </Fragment>
                })}

            </Modal>
        </div >
    )
}
const useStyles = makeStyles(theme => ({
    infoContainer: {
        borderBottomColor: theme.palette.common.white
    },
    infoName: {
        flex: 1
    },
    listItemTitle: {
        backgroundColor: theme.palette.primary.ultraLight,
        borderBottomColor: theme.palette.common.white,
        '& span': {
            flex: 1
        }
    },
    permissionTitle: {
        flex: 1,
        paddingLeft: 24
    }
}))


export default withTranslation()(PermissionsModal)